import React from "react";
import { Clock } from "lucide-react";

export function formatDuration(ms) {
  if (ms == null) return "--:--";
  if (ms <= 0) return "00:00";
  const totalSec = Math.floor(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

export function CountdownBadge({ ms, label, testid, showIcon = true }) {
  const min = ms != null ? ms / 60000 : Infinity;
  const color = min < 15 ? "text-red-400 border-red-500/40 bg-red-500/10"
    : min < 60 ? "text-amber-400 border-amber-500/40 bg-amber-500/10"
      : "text-[#b6ff2e] border-[#b6ff2e]/30 bg-[#b6ff2e]/5";
  return (
    <div data-testid={testid}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border ${color} font-display tabular`}>
      {showIcon && <Clock size={14} />}
      {label && <span className="text-[11px] uppercase tracking-wide opacity-70">{label}</span>}
      <span className="text-base font-bold">{formatDuration(ms)}</span>
    </div>
  );
}
